import ExternalEvents from "./ExternalEvents";
import animateValue, { updateHeight } from "../animateValue";
import { addKeydownEventListener } from "../keyboard";

export default class Expandable extends ExternalEvents {
    constructor(el, animationDuration = 250) {
        super(["open", "close"]);
        this.el = el;
        this.toggle = this.el.querySelector(".expandable__opener");
        this.content = this.el.querySelector(".expandable__content");
        this.openedByDefault = el.classList.contains("expandable--expanded");
        this.isOpened = this.openedByDefault;
        this.animationDuration = animationDuration;
    }

    toggleExpandable(open = null, e) {
        this.isOpened = open ?? !this.isOpened;

        const actionType = this.isOpened ? "add" : "remove";
        const maxHeight = !this.isOpened ? 0 : this.content.scrollHeight;

        animateValue(
            this.content,
            updateHeight,
            this.content.offsetHeight,
            maxHeight,
            this.animationDuration
        );

        this.runExternalEventHandlers(this.isOpened ? "open" : "close", e);

        if (this.openedByDefault) this.el.classList.remove("expandable--expanded");

        this.el.classList[actionType]("expandable--active");
    }

    handleToggleClick(e) {
        this.toggleExpandable(null, e);
    }

    handleEscapeEvent() {
        if (this.isOpened) this.toggleExpandable(false);
    }

    init() {
        if (!this.toggle || !this.content) return;

        this.toggle.addEventListener("click", this.handleToggleClick.bind(this));
        addKeydownEventListener(this.el, { Escape: [this.handleEscapeEvent.bind(this)] });
    }
}
